import React from 'react';
import { ValidationError } from './ValidationError';

interface ValidatedInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    name: string;
    error?: string | string[] | null;
    clampMin?: number; // For number fields, clamp to this min (e.g., 0)
    clampMax?: number; // For number fields, clamp to this min (e.g., 0)
}

export const ValidatedInput: React.FC<ValidatedInputProps> = ({
    label,
    name,
    type = 'text',
    value,
    onChange,
    error,
    clampMin,
    clampMax,
    disabled,
    className = '',
    ...props
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (type === 'number') {
            let numValue = parseFloat(e.target.value);
            if (isNaN(numValue)) numValue = clampMin ?? 0;
            if (clampMin !== undefined && numValue < clampMin) numValue = clampMin;
            if (clampMax !== undefined && numValue > clampMax) numValue = clampMax; // New max clamp
            e.target.value = numValue.toString();
        }
        if (onChange) onChange(e);
    };

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={name}>
                {label}
            </label>
            <input
                id={name}
                name={name}
                type={type}
                value={value}
                onChange={handleChange}
                disabled={disabled}
                className={`w-full border rounded-md px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 shadow-sm ${className} ${error ? 'border-red-300 bg-red-50/30' : 'border-gray-300'} ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : ''}`}
                {...(type === 'number' && clampMin !== undefined ? { min: clampMin } : {})}
                {...props}
            />
            <ValidationError error={error} />
        </div>
    );
};